// extracted by mini-css-extract-plugin
export default {"fullWidth":"Fn-z","image":"Gn-z","lazyLoadPicture":"Hn-z","lazyLoadSpinner":"In-z","lazyLoadSpin":"Jn-z","lazyLoadImage":"Kn-z","hasStyledAspectRatio":"Ln-z"};